import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineComponent } from '@app/components/elements/timeline/timeline/timeline.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';


@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		RouterModule,
		NzButtonModule
	],
	declarations: [
		TimelineComponent,
	],
	exports: [
		TimelineComponent,
	],
})
export class TimelineModule {}
